export default {
  "content": "<circle cx=\"12\" cy=\"12\" r=\"10.5\" fill=\"#4EC176\" stroke=\"#fff\" stroke-width=\"3\"/><g clip-path=\"url(#a)\"><path d=\"M16.375 7.625h-8.75a.625.625 0 000 1.25v6.875a.625.625 0 001.25 0v-3.465A.285.285 0 019.16 12h5.68a.285.285 0 01.285.285v3.465a.625.625 0 001.25 0V8.875a.625.625 0 100-1.25z\" fill=\"#fff\"/><path d=\"M12.767 10.75h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 110 1.25z\" fill=\"#4EC176\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(7 7)\" d=\"M0 0h10v10H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};